import * as React from 'react';
import { getId } from 'office-ui-fabric-react/lib/Utilities';
import MIPADatePicker from '../Common/datepicker';
import { MIAPACons } from "../../Utils/MipaConstant";
import { GraphRequest } from "../../Utils/GraphRequest";
import TaskAssignments from './TaskAssignment';
import MIPAChoiceAction from '../Common/ChoiceAction';
import { ServiceRequest } from "../../Utils/ServiceRequest";
import * as $ from "jquery";
import {
  getTheme,
  mergeStyleSets,
  FontWeights,
  //ContextualMenu,
  //Checkbox,
  //DefaultButton,
  Modal,
  //IDragOptions,
  IconButton
} from 'office-ui-fabric-react';
import {
  Dropdown,
  //DropdownMenuItemType, 
  IDropdownOption
}
  from 'office-ui-fabric-react/lib/Dropdown';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { FontSizes } from '@uifabric/styling';
import './planner.scss';
import Planobj from '../../Entity/plan';
import { IFacepilePersona } from 'office-ui-fabric-react/lib/Facepile';
import { CPlannerTask } from '../../Entity/PlannerTaskObj';
import { PersonaInitialsColor } from 'office-ui-fabric-react/lib/Persona';
import { IFacepileProps, OverflowButtonType } from 'office-ui-fabric-react/lib/Facepile';
import NewTaskLink from './TaskLink';
import { Helper } from '../../Utils/Helper';
import TaskCategory from './TaskCategory';
export interface IProps {
  closeMethod;
  selectedPlan?: string | number | string[] | number[] | null;
  plans: Planobj[];
  GraphHeader;
  Phrases,
  Users;
  Loadpic;
  UserEmail;
  APIHeader;
  APIServiceurl;
  flagemailfortask?;
  Updatetask;
  CurrenttaskTask?;
  CreateUpdatePlanTaskSuccessCallback?;
}

// Themed styles for the example.
const theme = getTheme();
const contentStyles = mergeStyleSets({
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch'
  },
  header: [
    // tslint:disable-next-line:deprecation
    theme.fonts['xLargePlus'],
    {
      flex: '1 1 auto',
      borderTop: `4px solid ${theme.palette.themePrimary}`,
      color: theme.palette.neutralPrimary,
      display: 'flex',
      fontSize: FontSizes.xLarge,
      alignItems: 'center',
      fontWeight: FontWeights.semibold,
      padding: '12px 12px 14px 24px'
    }
  ],
  body: {
    flex: '4 4 auto',
    padding: '0 24px 24px 24px',
    overflowY: 'hidden',
    selectors: {
      p: {
        margin: '14px 0'
      },
      'p:first-child': {
        marginTop: 0
      },
      'p:last-child': {
        marginBottom: 0
      }
    }
  }
});

const iconButtonStyles = mergeStyleSets({
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: 'auto',
    marginTop: '4px',
    marginRight: '2px'
  },
  rootHovered: {
    color: theme.palette.neutralDark
  }
});
const facepilePersonas: IFacepilePersona[] = [];
export default class NewPlanTask extends React.Component<IProps> {
  public plantask: CPlannerTask;
  public taskDetails = {
    description: '',
    previewType: 'automatic',
    references: {},
    checklist: {}
  };

  public planusers;
  public planBucketList;
  public RequestPending = 0;
  public ProgressIsShowing = false;
  public state = {
    isLoading: false,
    showlinkmodal: false,
    taskDetailsChanged:false
  };
  public SRequest = new ServiceRequest();
  public FromValidationMessages = null;
  public currentgroupid = null;
  public facepileProps: IFacepileProps = {
    personas: facepilePersonas,
    maxDisplayablePersonas: 5,
    overflowButtonType: OverflowButtonType.none,
    overflowButtonProps: {
      ariaLabel: 'More users',
      onClick: (ev: React.MouseEvent<HTMLButtonElement>) => alert('overflow icon clicked')
    },
    ariaDescription: 'To move through the items use left and right arrow keys.'
  };
  private _titleId: string = getId('title');
  private _subtitleId: string = getId('subText');
  private plancategory = {
    category1: '',
    category2: '',
    category3: '',
    category4: '',
    category5: '',
    category6: ''
  };
  /*  private _dragOptions: IDragOptions = {
     moveMenuItemText: 'Move',
     closeMenuItemText: 'Close',
     menu: ContextualMenu
   }; */
  private inputOpenFileRef;
  constructor(props) {
    super(props);
    this.plantask = new CPlannerTask();
    this.plantask.startDateTime = new Date();
    this.plantask.dueDateTime = new Date();
    this.plantask.priority = 7;



    this.inputOpenFileRef = React.createRef();
    if (this.props.flagemailfortask) {
      this.plantask.title = this.props.flagemailfortask.subject;
      this.plantask.description = Helper.stripfromhtml(this.props.flagemailfortask.body.content);
    }
  }
  // Use getId() to ensure that the IDs are unique on the page.
  // (It's also okay to use plain strings without getId() and manually ensure uniqueness.)


  public componentDidMount() {
    $('.noteitem').css('z-index', 0);
    if (this.props.CurrenttaskTask) {
      this.plantask.startDateTime = this.props.CurrenttaskTask.startDateTime != null ? new Date(this.props.CurrenttaskTask.startDateTime) : null;
      this.plantask.dueDateTime = this.props.CurrenttaskTask.dueDateTime != null ? new Date(this.props.CurrenttaskTask.dueDateTime) : null;
      this.plantask.priority = this.props.CurrenttaskTask.priority;
      this.plantask.title = this.props.CurrenttaskTask.title;
      this.plantask.percentComplete = this.props.CurrenttaskTask.percentComplete;
      this.plantask.appliedCategories = JSON.parse(JSON.stringify(this.props.CurrenttaskTask.appliedCategories));
      this.plantask.assignments = JSON.parse(JSON.stringify(this.props.CurrenttaskTask.assignments));
      this.plantask.id = this.props.CurrenttaskTask.id;
      this.plantask.bucketId = this.props.CurrenttaskTask.bucketId;
      this.plantask.planId = this.props.CurrenttaskTask.planId;

      this.GetTaskDetails(this.props.CurrenttaskTask.id, (response) => {
        if (response && response.data) {
          this.taskDetails = response.data;
          this.plantask.description = this.taskDetails.description;
          this.planechange(null, null);
        }
      });
    }
  }
  public render() {
    let taskStatus = [
      {
        key: 0,
        text: this.props.Phrases.notstarted
      },
      {
        key: 50,
        text: this.props.Phrases.inprogress
      },
      {
        key: 100,
        text: this.props.Phrases.completed
      }
    ];
    let taskpriority = [
      {
        key: 1,
        text: this.props.Phrases.urgent
      },
      {
        key: 4,
        text: this.props.Phrases.important
      },
      {
        key: 7,
        text: this.props.Phrases.medium
      },
      {
        key: 9,
        text: this.props.Phrases.low
      },
    ];
    this.PrepareFacepile();
    let plandropdownitem = [];
    this.props.plans.forEach(p => {
      plandropdownitem.push({ key: p.id, text: p.title, groupid: p.owner });
    });
    Helper.SortList(plandropdownitem, 'text', true, false);
    /* let categoryTab1='task-details-category-tab category1 checkIcon ms-Icon'+
            (this.plantask.appliedCategories && 
              this.plantask.appliedCategories['category1']?' ms-Icon--Accept':'');
    let categoryTab2='task-details-category-tab category2 checkIcon ms-Icon'+
            (this.plantask.appliedCategories && 
              this.plantask.appliedCategories['category2']?' ms-Icon--Accept':'');
    let categoryTab3='task-details-category-tab category3 checkIcon ms-Icon'+
            (this.plantask.appliedCategories && 
              this.plantask.appliedCategories['category3']?' ms-Icon--Accept':'');
    let categoryTab4='task-details-category-tab category4 checkIcon ms-Icon'+
            (this.plantask.appliedCategories && 
              this.plantask.appliedCategories['category4']?' ms-Icon--Accept':'');

    let categoryTab5='task-details-category-tab category5 checkIcon ms-Icon'+
            (this.plantask.appliedCategories && 
              this.plantask.appliedCategories['category5']?' ms-Icon--Accept':'');
    let categoryTab6='task-details-category-tab category6 checkIcon ms-Icon'+
          (this.plantask.appliedCategories && 
            this.plantask.appliedCategories['category6']?' ms-Icon--Accept':''); */
    let checklistcaption = this.props.Phrases.checklist;
    return (
      <div className="Planner">

        <Modal
          titleAriaId={this._titleId}
          subtitleAriaId={this._subtitleId}
          isOpen={true}
          onDismiss={() => {
            this.props.closeMethod(false);
          }}
          isBlocking={true}
          containerClassName={contentStyles.container}
        /* dragOptions={this._dragOptions} */
        >
          <div className={contentStyles.header}>
            <span id={this._titleId}>{this.props.Phrases.newplantask}</span>
            {this.state.isLoading ? (
              <div className="mipaloading">&nbsp;</div>
            ) : null}
            <IconButton
              styles={iconButtonStyles}
              iconProps={{ iconName: 'Cancel' }}
              ariaLabel="Close popup modal"
              onClick={() => {
                this.props.closeMethod(false);
              }}
            />
          </div>
          {plandropdownitem.length > 0 || this.props.CurrenttaskTask != null ? (
            <div id={this._subtitleId} className={contentStyles.body}>
              <div className='ms-Grid-row'>
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                  <input ref={this.inputOpenFileRef} type="file" style={{ display: 'none' }} onChange={this.changefile} />
                  {this.props.CurrenttaskTask ? (
                    <span>{this.props.CurrenttaskTask.planeName}</span>
                  ) : (
                    <React.Fragment>

                      <Dropdown
                        label={this.props.Phrases.plancaption}
                        selectedKey={this.props.selectedPlan}
                        onChange={this.planechange}
                        placeholder={this.props.Phrases.selectplan}
                        options={plandropdownitem}
                        styles={{ dropdown: { width: '100%' } }}
                      />
                    </React.Fragment>

                  )}


                </div>
              </div>
              <div className="ms-Grid-row">

                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                  <TextField
                    onChange={(e) => {
                      this.changetextvalue(e, 'title');
                    }}
                    label={this.props.Phrases.tasktitlecaption}
                    value={this.plantask.title}
                    placeholder={this.props.Phrases.textplaceholder}
                  />
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 notebox">
                  <TaskAssignments
                    data={this.plantask}
                    Users={this.props.Users}
                    groupMembers={this.planusers}
                    facepileProps={this.facepileProps}
                    facepilePropsAssignedby={[]}
                    facepilePropsCreatedBy={[]}
                    Header={this.props.GraphHeader}
                    Phrases={this.props.Phrases}
                    ReloadPlannerTasks={() => { }}
                    Progress={this.ShowHideProgress}
                    Loadpic={this.props.Loadpic}
                    AssignedUsermethod={(selecteduser) => {
                      this.plantask.assignments = selecteduser.assignments;
                      this.setState({ chagnevalue: new Date() });
                    }}
                  />
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                  <TaskCategory AddCategoryMethod={(newappliedcatlist) => {
                    this.plantask.appliedCategories = newappliedcatlist;
                  }}
                    Phrases={this.props.Phrases}
                    appliedCategories={this.plantask.appliedCategories}
                    categoryDescriptions={this.plancategory}
                  />
                  {/* <div className="fieldcaption ms-Label ms-Dropdown-label label-180">
                      <i className="ms-Icon ms-Icon--Tag" aria-hidden="true"></i>
                         Categories</div>
                      <div className='categorycontainer'></div>
                      <div style={{display:'none'}}>
                        <i className={categoryTab1} title={this.plancategory.category1} onClick={()=> {this.changecategory(1,categoryTab1);}} id="categoryTab1">
                        <span className="catlabel">{this.plancategory.category1}</span> 
                      </i>
                      <i className={categoryTab2} title={this.plancategory.category2} onClick={()=> {this.changecategory(2,categoryTab2);}} id="categoryTab2">
                        <span className="catlabel">{this.plancategory.category2}</span> 
                      </i>
                      <i className={categoryTab3} title={this.plancategory.category3} onClick={()=> {this.changecategory(3,categoryTab3);}} id="categoryTab3">
                        <span className="catlabel">{this.plancategory.category3}</span>
                      </i>
                      <i className={categoryTab4} title={this.plancategory.category4} onClick={()=> {this.changecategory(4,categoryTab4);}} id="categoryTab4">
                        <span className="catlabel">{this.plancategory.category4}</span>
                      </i>
                      <i className={categoryTab5} title={this.plancategory.category5} onClick={()=> {this.changecategory(5,categoryTab5);}} id="categoryTab5">
                        <span className="catlabel">{this.plancategory.category5}</span>                      
                      </i>
                      <i className={categoryTab6} title={this.plancategory.category6} onClick={()=> {this.changecategory(6,categoryTab6);}} id="categoryTab6">
                        <span className="catlabel">{this.plancategory.category6}</span>
                      </i>
                      </div> */}

                  <div className="mtb8" style={{ "clear": 'both', 'marginBottom': '5px' }} />
                </div>

              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4">
                  <Dropdown
                    label={this.props.Phrases.bucket}
                    selectedKey={this.plantask.bucketId}
                    onChange={this._onBucketChange}
                    placeholder={this.props.Phrases.selectbucket}
                    options={this.planBucketList}
                    styles={{ dropdown: { width: '100%' } }}
                  />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4">
                  <Dropdown
                    label={this.props.Phrases.progress}
                    selectedKey={this.plantask.percentComplete}
                    onChange={this.changestatus}
                    placeholder={this.props.Phrases.selecttaskstatus}
                    options={taskStatus}
                    styles={{ dropdown: { width: '100%' } }}
                  />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4">
                  <Dropdown
                    label={this.props.Phrases.priority}
                    selectedKey={this.GetPriority()}
                    onChange={this.changepriority}
                    //placeholder={this.props.Phrases.selecttaskstatus}
                    options={taskpriority}
                    styles={{ dropdown: { width: '100%' } }}
                  />
                </div>
              </div>

              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4">
                  <div className="fieldcaption ms-Label ms-Dropdown-label label-150">{this.props.Phrases.start}</div>
                  <MIPADatePicker
                    showIcon={false}
                    datevalue={this.plantask.startDateTime}
                    ChangeDate={(date) => {
                      this.plantask.startDateTime = date;
                    }} />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4">
                  <div className="fieldcaption ms-Label ms-Dropdown-label label-150">{this.props.Phrases.due}</div>
                  <MIPADatePicker
                    showIcon={false}
                    datevalue={this.plantask.dueDateTime}
                    ChangeDate={(date) => {
                      this.plantask.dueDateTime = date;
                    }} />
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                  <Checkbox
                    label={this.props.Phrases.showoncard}
                    className="cardcheck"
                    onChange={this.descriptionpreview}
                    checked={this.taskDetails.previewType == 'description' ? true : false}
                  />
                  <div className="clear" />
                  <TextField
                    className=""
                    onChange={(e) => {
                      this.changetextvalue(e, 'description');
                    }}
                    value={this.plantask.description}
                    label={this.props.Phrases.desctrictioncaption}
                    multiline={true}
                    autoAdjustHeight={true}
                  />
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">

                  <Checkbox
                    label={this.props.Phrases.showoncard}
                    className="cardcheck"
                    onChange={this.checklistpreview}
                    checked={this.taskDetails.previewType == 'checklist' ? true : false}
                  />

                  <div className="fieldcaption ms-Label ms-Dropdown-label label-150">{checklistcaption}</div>
                  <div id="dvchecklistconainer">
                    {this.getchecklistitems()}
                  </div>
                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                  <MIPAChoiceAction contextbuttoncss='contextbutton' items={this.PrepareAttachmentItems()}>
                    {this.props.Phrases.addattachment}
                  </MIPAChoiceAction>

                  <div className="linkContainer">
                    {this.PrepareExtRefForUI()}
                  </div>
                </div>
              </div>

              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 notebox">
                  <ul className="error">
                    {this.FromValidationMessages}
                  </ul>

                </div>
              </div>
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                  <div className="buttonarea">
                    <button onClick={this.createPlanTask} className="ms-Button ms-Button--default viewswitchbtn plannertask">
                      {this.props.Phrases.save}
                    </button>
                    <button
                      className="ms-Button ms-Button--default viewswitchbtn"
                      onClick={this.props.closeMethod as any}
                    >
                      {this.props.Phrases.cancel}
                    </button>
                  </div>

                </div>
              </div>
            </div>
          ) : (<b>You must have at least one Plan and task assigned to yourself before you can use Planner in MIPA.</b>)}

        </Modal>
        {this.state.showlinkmodal ?
          <NewTaskLink
            closeMethod={this.ShowHideLinkModal}
            setTasklink={this.SaveLinkToTask}
            phrases={this.props.Phrases}
          /> : null
        }

      </div>
    );
  }
  private PrepareExtRefForUI = () => {
    if (this.taskDetails == null || this.taskDetails.references == null) {
      return null;
    }
    let reflist = [];
    Object.keys(this.taskDetails.references).forEach((key) => {
      let objAttach = this.taskDetails.references[key];
      reflist.push(
        <span key={key} className="extrefitem">
          <a
            href={decodeURIComponent(key)}
            target="_blank"
          >
            {objAttach.alias}
          </a>
          <i
            className="ms-Icon ms-Icon--BoxMultiplySolid"
            title={this.props.Phrases.remove}
            onClick={() => { this.RemoveLinkFromTask(key) }}
          />
        </span>
      );
    });

    return reflist;
  }
  private PrepareFacepile = () => {
    this.facepileProps.personas = [];
    for (var assignedTo in this.plantask.assignments) {
      if (this.plantask.assignments[assignedTo] != null) {
        let user = this.props.Users.filter(u => u.id == assignedTo);
        if (user && user.length > 0) {
          user = user[0];
          // assignecount++;
          if (user.surname == null) {
            user.surname = user.givenName;
          }
          let AssingeeInitial = user.givenName != null ? user.givenName.trim().substr(0, 1).toUpperCase() + user.surname.trim().substr(0, 1).toUpperCase() : user.displayName.trim().substr(0, 2).toUpperCase();
          let persion = {
            //imageUrl: 'https://cdn1.iconfinder.com/data/icons/user-pictures/100/male3-512.png',
            imageUrl: Helper.GetDefaultImage(),
            imageInitials: AssingeeInitial,
            personaName: user.displayName,
            initialsColor: PersonaInitialsColor.magenta
          };

          if (user.imagepath == null || user.imagepath == '') {
            this.props.Loadpic(user.id);
          } else {
            persion.imageUrl = user.imagepath;
          }
          this.facepileProps.personas.push(persion);
          // plan=myPlanList.filter(p=> p.id==item.planId);
        }
      }
    }
  }
  private createPlanTask = () => {
    this.FromValidationMessages = [];
    let planobj = {
      assignments: this.plantask.assignments,
      planId: this.plantask.planId,
      bucketId: this.plantask.bucketId,
      title: this.plantask.title,
      dueDateTime: this.plantask.dueDateTime,
      startDateTime: this.plantask.startDateTime,
      percentComplete: this.plantask.percentComplete,
      appliedCategories: this.plantask.appliedCategories,
      priority: this.plantask.priority
    };
    this.taskDetails.description = this.plantask.description;
    if (this.ValidateTaskForm()) {
      let creatingNewTask = false;
      let taskoperationsuccess = (response) => {
        this.UpdatePlanTaskDescription(response.data.id, true, creatingNewTask);
      };

      if (this.props.CurrenttaskTask != null) {
        delete planobj.planId;
        for (const property in this.props.CurrenttaskTask.appliedCategories) {
          if (planobj.appliedCategories[property] == null) {
            planobj.appliedCategories[property] = false;
          }
        }
        for (const property in this.props.CurrenttaskTask.assignments) {
          if (planobj.assignments[property] == null) {
            planobj.assignments[property] = null;
          } else {
            delete planobj.assignments[property];
          }
        }

        let header = { ...this.props.GraphHeader };
        header["If-Match"] = this.props.CurrenttaskTask['@odata.etag'];
        header["Prefer"] = "return=representation";
        let api =
          MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.PlannerTaks + "/" + this.props.CurrenttaskTask.id;


        creatingNewTask = false;
        GraphRequest.Patch(
          api,
          header,
          planobj,
          taskoperationsuccess,
          (error) => {
            alert('Fail to update task');
          },
          this.ShowHideProgress
        );
      } else {
        creatingNewTask = true;
        let taskurl = MIAPACons.GraphAPI.GraphBaseURL +
          MIAPACons.GraphAPI.PlannerTaks;
        GraphRequest.POST(taskurl, this.props.GraphHeader, planobj,
          taskoperationsuccess,
          (error) => {
            alert('Fail to create task');
          },
          this.ShowHideProgress);
      }
    } else {
      this.setState({ chagnevalue: new Date() });
    }
  }

  private UpdatePlanTaskDescription = (taskid, isCreate, creatingNewTask: boolean) => {

    let newdetails = this.taskDetails;
    if ((newdetails.description && newdetails.description.trim() != '') || this.state.taskDetailsChanged) {

      let taskdetails;

      this.GetTaskDetails(taskid, (response) => {
        if (response && response.data) {
          let taskurl = MIAPACons.GraphAPI.GraphBaseURL +
            MIAPACons.GraphAPI.TaskDetail.replace("{0}", taskid) + Math.round(+new Date() / 1000);
          taskdetails = response.data;
          let header = { ...this.props.GraphHeader };
          let etag = taskdetails["@odata.etag"];
          header["If-Match"] = etag;
          header["Prefer"] = "return=representation";
          var detailsprops = ['description', 'previewType', 'automatic', 'noPreview'];
          for (var i = 0; i < detailsprops.length; i++) {
            taskdetails[detailsprops[i]] = this.taskDetails[detailsprops[i]];
          }

          for (const property in taskdetails.checklist) {
            taskdetails.checklist[property] = null;
          }

          for (const property in this.taskDetails.checklist) {
            taskdetails.checklist[property] = this.taskDetails.checklist[property];
            if (taskdetails.checklist[property]) {
              delete taskdetails.checklist[property].lastModifiedBy;
              delete taskdetails.checklist[property].lastModifiedDateTime;
              delete taskdetails.checklist[property].orderHint;
            }
          }
          for (const property in taskdetails.references) {
            taskdetails.references[property] = null;
          }
          for (const property in this.taskDetails.references) {
            taskdetails.references[property] = this.taskDetails.references[property];
            if (taskdetails.references[property].previewPriority == "  !!") {

            } else {
              delete taskdetails.references[property];
            }
          }
          GraphRequest.Patch(
            taskurl, header, taskdetails,
            (detailsresponse) => {
              this.props.closeMethod(true, creatingNewTask);
            },
            (detailserror) => {
              alert('Fail to create task');
            },
            this.ShowHideProgress);
        } else {
          setTimeout(() => {
            this.UpdatePlanTaskDescription(taskid, isCreate, creatingNewTask);
          }, 9000);
        }
      });


    } else {
      this.props.closeMethod(true, creatingNewTask);
    }
  }
  private GetTaskDetails = (taskid, fnsuccess) => {
    let taskurl = MIAPACons.GraphAPI.GraphBaseURL +
      MIAPACons.GraphAPI.TaskDetail.replace("{0}", taskid) + Math.round(+new Date() / 1000);
    GraphRequest.GET(
      taskurl, this.props.GraphHeader,
      (response) => {
        fnsuccess(response);

      },
      (error) => {
        alert('Fail to create task');
      },
      this.ShowHideProgress);
  }

  private ValidateTaskForm = (): boolean => {


    if (this.plantask.planId == null || this.plantask.planId == '') {
      this.FromValidationMessages.push(<li key="planid">{this.props.Phrases.planselectvalidaiton}</li>);
    }
    if (this.plantask.title == null || this.plantask.title == '') {
      this.FromValidationMessages.push(<li key="tasktitle">{this.props.Phrases.tasktitlevalidaiton}</li>);
    }
    if (this.plantask.bucketId == null || this.plantask.bucketId == '') {
      this.FromValidationMessages.push(<li key="taskbucket">{this.props.Phrases.bucketvalidation}</li>);
    }
    if (this.plantask.assignments == null || Object.keys(this.plantask.assignments).length == 0) {
      this.FromValidationMessages.push(<li key="assigne">{this.props.Phrases.taskassigneevalidation}</li>);
    }
    let checklistkeys = Object.keys(this.taskDetails.checklist);
    checklistkeys.map((key) => {
      let checklisttitle = this.taskDetails.checklist[key].title.trim();
      if (checklisttitle && checklisttitle != '') {
        this.taskDetails.checklist[key].title = checklisttitle;
      } else {
        this.FromValidationMessages.push(<li key={key}>{this.props.Phrases.checklistvalidation}</li>);

      }
    });


    return this.FromValidationMessages.length == 0;
  }
  /* private changecategory=(index,currentclss:string)=> {
    let prop='category'+index;
    let  value= !(currentclss.indexOf('ms-Icon--Accept')>0);
    this.plantask.appliedCategories[prop]=value;
    this.setState({ chagnevalue:new Date() });
    
  } */
  private planechange = async (event: React.FormEvent<HTMLDivElement>, item) => {
    this.planBucketList = [];
    let tempplanBucketList = [];
    if (this.props.CurrenttaskTask == null) {
      this.plantask.bucketId = '';
      this.FromValidationMessages = [];
      this.currentgroupid = item['groupid'];
      this.plantask.planId = item['key'];

      let bucketapi =
        MIAPACons.GraphAPI.GraphBaseURL +
        MIAPACons.GraphAPI.PlanBuckets.replace("{0}", this.plantask.planId);

      tempplanBucketList = tempplanBucketList.concat(
        await GraphRequest.GetPlannerBuckets(
          bucketapi,
          this.props.GraphHeader,
          this.ShowHideProgress
        )
      );
    } else {

      this.FromValidationMessages = [];
      this.currentgroupid = this.props.CurrenttaskTask.groupId;
      tempplanBucketList = this.props.CurrenttaskTask.buckets;
    }
    tempplanBucketList.forEach(p => {
      this.planBucketList.push({ key: p.id, text: p.name });
    });
    let groupmemberapi = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.GroupMembers.replace("{0}", this.currentgroupid);
    this.planusers = await GraphRequest.GetItemsByGraph(groupmemberapi, [], this.props.GraphHeader, this.ShowHideProgress);
    this.LoadPlandetails(this.plantask.planId);
  }

  private _onBucketChange = (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption): void => {
    this.plantask.bucketId = item.key.toString();
    this.setState({ chagnevalue: new Date() });
  }
  private changestatus = (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption): void => {
    this.plantask.percentComplete = parseInt(item.key.toString(), 0);
    this.setState({ chagnevalue: new Date() });
  }
  private GetPriority = () => {
    //1,4,7,9
    let p = 7;
    switch (this.plantask.priority) {
      case 0:
      case 1:
        p = 1;
        break;
      case 2:
      case 3:
      case 4:
        p = 4;
        break;
      case 5:
      case 6:
      case 7:
        p = 7;
        break;
      case 8:
      case 9:
      case 10:
        p = 9
        break;
    }
    return p;
  }
  private changepriority = (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption): void => {
    this.plantask.priority = parseInt(item.key.toString(), 0);
    this.setState({ chagnevalue: new Date() });
  }
  private changetextvalue = (event, prop): void => {
    this.plantask[prop] = event.target.value;
    this.setState({ chagnevalue: new Date() });
  }
  private descriptionpreview = (event) => {
    this.taskDetails.previewType = event.target.checked ? 'description' : 'automatic';
    this.setState({ chagnevalue: new Date() });
  }
  private checklistpreview = (event) => {
    this.taskDetails.previewType = event.target.checked ? 'checklist' : 'automatic';
    this.setState({ chagnevalue: new Date() });
  }
  private ShowHideProgress = value => {
    /*if(this.RequestPending==0 && value<0){
      return;
    }*/
    this.RequestPending += value;
    if (this.RequestPending <= 0) {
      this.RequestPending = 0;
      if (this.ProgressIsShowing) {
        this.setState({ isLoading: false });
        this.ProgressIsShowing = false;
      }
    } else if (this.ProgressIsShowing == false) {
      this.ProgressIsShowing = true;
      this.setState({ isLoading: true });
    }
  }
  private ShowHideLinkModal = (value) => {
    this.setState({ showlinkmodal: value });
  }
  private SaveLinkToTask = (extref) => {
    if (extref) {
      this.taskDetails.references[extref.prop] = extref.refval;
      this.setState({ showlinkmodal: false, chagnevalue: new Date(),taskDetailsChanged:true });
    } else {
      this.setState({ showlinkmodal: false });
    }
  }
  private RemoveLinkFromTask = (refprop) => {
    delete this.taskDetails.references[refprop];
    this.setState({ chagnevalue: new Date(),taskDetailsChanged:true  });
  }
  private PrepareAttachmentItems = () => {
    let menus = [];
    let inputref = this.inputOpenFileRef;
    menus.push(
      {
        key: 'attachment_file',
        name: this.props.Phrases.attachfile,
        /* iconProps: {
          className: this.props.data.percentComplete==0 ? 'ms-Icon ms-Icon--RadioBtnOn' : 'ms-Icon ms-Icon--RadioBtnOff'
        }, */
        onClick: () => {
          this.showOpenFileDlg(inputref);
        }
      }
    );

    menus.push(
      {
        key: 'attachment_link',
        name: this.props.Phrases.attachlink,
        /* iconProps: {
          className: this.props.data.percentComplete==0 ? 'ms-Icon ms-Icon--RadioBtnOn' : 'ms-Icon ms-Icon--RadioBtnOff'
        }, */
        onClick: () => {
          this.ShowHideLinkModal(true);
        }
      }
    );
    if (this.props.flagemailfortask) {
      menus.push(
        {
          key: 'attachment_mail',
          name: this.props.Phrases.attachmail,
          /* iconProps: {
            className: this.props.data.percentComplete==0 ? 'ms-Icon ms-Icon--RadioBtnOn' : 'ms-Icon ms-Icon--RadioBtnOff'
          }, */
          onClick: () => {
            this.UploadEmailToGroup();
          }
        }
      );
    }
    return menus;
  }
  private showOpenFileDlg = (inputref) => {
    this.FromValidationMessages = [];
    if (this.currentgroupid) {
      inputref.current.click();
    } else {
      this.FromValidationMessages.push(<li key="planid">{this.props.Phrases.planselectvalidaiton}</li>);
      this.setState({ chagnevalue: new Date() });
    }

  }
  private UploadEmailToGroup = () => {
    var obj = {
      ID: "0",
      FileName: this.props.flagemailfortask.subject ? this.props.flagemailfortask.subject : '[no subject]',
      Content: this.props.flagemailfortask.id

    };
    this.PerformAttachment([obj]);
  }
  private changefile = (e) => {
    let fileInput = this.inputOpenFileRef.current;
    if (fileInput.files == null || fileInput.files.length <= 0) {
      return;
    }
    let file = fileInput.files[0];
    let name = file.name;
    let reader = new FileReader();
    reader.onload = (event: Event) => {
      let obj = {
        ID: 'NOID',
        FileName: name,
        Content: ''
        //FileContentbytes: new Uint8Array(result.target.result)

      };

      let fileData = '';

      let byteArray = new Uint8Array(event.target["result"]);
      //let byteArray = new Uint8Array(reader.result);
      for (var i = 0; i < byteArray.byteLength; i++) {
        fileData += String.fromCharCode(byteArray[i]);
      }
      obj.Content = btoa(fileData);

      var Attachobj = [obj];
      this.PerformAttachment(Attachobj);
      //fileInput.val('');
    };
    //reader.readAsBinaryString(file);
    reader.readAsArrayBuffer(file);
  }
  private PerformAttachment = (Attachobj) => {
    // let rooturl=MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.rootsite;
    // GraphRequest.GET(rooturl,this.props.GraphHeader,(rootresult)=> {
    let SPUL = ''; // rootresult.data.webUrl;
    let groupURL = '';
    let groupdetailsurl = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.GroupWeb.replace('{0}', this.currentgroupid);
    GraphRequest.GET(groupdetailsurl, this.props.GraphHeader, (groupresult) => {
      groupURL = groupresult.data.value;
      try {
        var groupsp = new URL(groupURL);
        SPUL = groupsp.protocol + '//' + groupsp.host;
        groupURL = groupURL.replace(SPUL, '');
      } catch (ex) {
        console.log(ex);
      }
      let lastIndex = groupURL.lastIndexOf('/');
      groupURL = groupURL.substr(0, lastIndex);
      /*let lastIndex = groupresult.data.value.lastIndexOf('/');
      groupURL = groupresult.data.value.substr(0, lastIndex);
      lastIndex = groupURL.lastIndexOf('/');
      groupURL = groupURL.substr(lastIndex);
      */
      let objRequest = {
        SPURL: SPUL,
        GroupURL: groupURL,
        UserEmail: this.props.UserEmail,
        GroupFiles: Attachobj
      };
      this.UploadfiletoGroup(objRequest);
    }, (grouperror) => { }, this.ShowHideProgress);

    // },               (rooterror)=> {},this.ShowHideProgress);

  }
  private UploadfiletoGroup = (objRequest) => {
    let fnSuccess = result => {

      for (var i = 0; i < result.data.length; i++) {
        var lnk = result.data[i].path.replace(':', '%3A');
        lnk = lnk.replace(/\./g, '%2E');
        let newValue = {
          prop: lnk,
          refval: {
            "@odata.type": "microsoft.graph.plannerExternalReference",
            "alias": result.data[i].FileName,
            "previewPriority": "  !!"
          }
        };
        this.SaveLinkToTask(newValue);
      }

    };
    let fnerror = error => {

    };
    var api =
      "/AddAttachmentToGroup";
    this.SRequest.Post(
      this.props.APIServiceurl,
      api,
      objRequest,
      fnSuccess,
      fnerror,
      this.ShowHideProgress,
      this.props.APIHeader
    );
  }
  private getchecklistitems = () => {
    let checkitems = [];
    let rowcss = "ms-Grid-row miparow";
    Object.keys(this.taskDetails.checklist).map((key) => {
      checkitems.push(
        <div className={rowcss} key={key}>
          <div className="ms-Grid-col ms-sm10 taskchecklist taskchecklistentry">
            <Checkbox
              label=''
              defaultChecked={this.taskDetails.checklist[key].isChecked}
              onChange={(ev: React.FormEvent<HTMLElement>, isChecked: boolean) => {
                this.taskDetails.checklist[key].isChecked = isChecked;
              }}
            />
            <input
              className="ms-TextField-field field-183"
              placeholder={this.props.Phrases.textplaceholder}
              onChange={(e) => { this.setchecklisttitle(e.target.value, key); }}
              type="text"
              value={this.taskDetails.checklist[key].title} />



          </div>
          <div className="ms-Grid-col ms-sm2 alignright">
            <i
              title={this.props.Phrases.remove}
              onClick={() => {
                delete this.taskDetails.checklist[key];
                this.setState({ chagnevalue: new Date(),taskDetailsChanged:true  });
              }
              }
              className="ms-Icon ms-Icon--Delete checkaction checkdelete"
            />
          </div>
          {/* <div className="ms-Grid-col ms-sm3 ms-u-textAlignRight">
                  <CheckItemAction referenceid={key} 
                                   Update={this.CheckItemActionUpdate} 
                                   Phrases={this.props.Phrases} 
                                   Title={TaskDetails.checklist[key].title}
                                   />
              </div> */}
        </div>
      );
    });
    checkitems.push(
      <div key="newchecklist">
        <button onClick={this.Addchecklisttotask} title={this.props.Phrases.addchecklist} className="ms-Button ms-Button--default plannertask">
          <i className="ms-Icon ms-Icon--Add" />
        </button>
      </div>
    );
    return checkitems;
  }
  private Addchecklisttotask = () => {
    this.taskDetails.checklist[Helper.newguid()] = {
      "@odata.type": "microsoft.graph.plannerChecklistItem",
      isChecked: false,
      title: ''
    };
    this.setState({ chagnevalue: new Date(),taskDetailsChanged:true  });
  }
  private setchecklisttitle = (val, prop) => {
    this.taskDetails.checklist[prop].title = val;
    this.setState({ chagnevalue: new Date(),taskDetailsChanged:true  });
  }

  private LoadPlandetails = (planid) => {

    //let detailapi=MIAPACons.GraphAPI.GraphBaseURL+MIAPACons.GraphAPI.PlanDetails.replace('{0}',planid); 
    let detailapi = MIAPACons.GraphAPI.GraphBaseURL + MIAPACons.GraphAPI.PlanDetailsbeta.replace('{0}', planid);
    GraphRequest.GET(detailapi, this.props.GraphHeader, (detail) => {
      this.plancategory = detail.data.categoryDescriptions;
      this.setState({ chagnevalue: new Date() });
    },
      (error) => {

      },
      this.ShowHideProgress);

  }
}
